export default __webpack_public_path__ + "5b61f4efe3135b6197a49c44d427dda2.png";